<div class="demo"><iframe :src="src" :title="title" loading="lazy" allow="autoplay; fullscreen" allowfullscreen></iframe></div>